// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Person } from './person';

/// <code-import> Place custom imports between <code-import> tags
import { UtilityService } from '../core.module';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class BackgroundCheck extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get submittedLocal() {
        return UtilityService.utcToLocal(this.submitted, false);
    }
    set submittedLocal(value) {
        this.submitted = UtilityService.localToUtc(value);
    }

    get receivedLocal() {
        return UtilityService.utcToLocal(this.received, false);
    }
    set receivedLocal(value) {
        this.received = UtilityService.localToUtc(value);
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: string;
  cleared?: boolean;
  personId!: number;
  received?: Date;
  submitted?: Date;
  person!: Person;
}

